import { Injectable, OnDestroy, inject } from '@angular/core';
import { CustomMatDialogService } from '@app/core/services/mat-dialog.service';
import { dialogWidth } from '@app/core/constants/themes';
import { Environment } from '@app/core/models/environment.model';
import { AppData } from '@app/shared/models/appdata.model';
import { CommandPaletteComponent } from './command-palette/command-palette.component';

// Only import in app component!
@Injectable({ providedIn: 'root' })
export class DevToolsService implements OnDestroy {
  private dialog = inject(CustomMatDialogService);
  private appData = inject(AppData);

  constructor() {
    window.addEventListener('keydown', this.handleKeydown);
  }

  private handleKeydown = (event: KeyboardEvent): void => {
    if (this.appData.environment === Environment.Production) {
      return;
    }
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      this.openCommandPalette();
    }
  };

  private openCommandPalette(): void {
    const alreadyOpen = this.dialog.openDialogs.some(
      dialogRef => dialogRef.componentInstance instanceof CommandPaletteComponent
    );
    if (alreadyOpen) {
      return;
    }

    this.dialog.open(CommandPaletteComponent, {
      width: dialogWidth,
      panelClass: 'ice-custom-panel',
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('keydown', this.handleKeydown);
  }
}
